import { useAppConfigContext } from "../context/AppConfigContext";

function AssistantOnboardingHeader() {
  const { config } = useAppConfigContext();

  return (
    <header className="sticky inset-x-0 top-0 z-40 border-b border-[#F2F4F7] bg-white/95 backdrop-blur">
      <div className="mx-auto flex h-20 max-w-6xl items-center justify-center px-4">
        <img
          src={config.logoUrl || "/images/logo.png"}
          alt={config.appName || "Pulo logo"}
          className="h-8 w-auto"
        />
      </div>
    </header>
  );
}

export default AssistantOnboardingHeader;
